export default __webpack_public_path__ + "static/background-388892175a82f43cdc69b73afcc7c72c.webm";